<template>
  <div id="app" class="d-flex flex-column h-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
          <h1 id="title">listwise</h1>
          <nav-bar></nav-bar>
          <transition name="component-fade" mode="out-in">
            <router-view :key="$route.path" />
          </transition>
          <copy-item-modal></copy-item-modal>
        </div>
      </div>
    </div>
    <div class="footer mt-auto d-flex justify-content-center">
      <ul class="nav justify-content-center d-flex align-items-center">
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'about' }">About</router-link>
        </li>
        <li class="nav-item mx-5">
          <a
            class="nav-link store-button"
            href="https://play.google.com/store/apps/details?id=ca.strig.listwise&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            ><img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CopyItemModal from "@/components/CopyItemModal"
import NavBar from "@/components/NavBar"
import { mapState, mapGetters } from "vuex"

export default {
  name: "App",
  components: {
    CopyItemModal,
    NavBar,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
    }),
    ...mapGetters({
      isAuth: "users/isAuth",
    }),
  },
  methods: {
    logOut() {
      this.$store.dispatch("users/logOutUser")
    },
  },
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

#app .footer {
  padding: 8px 0;
  background: #202022;
  border-top: 2px solid #1d8cf8;
  .nav {
    padding-top: 0;
    .nav-link {
      font-size: 0.9rem;
    }
    .store-button {
      max-width: 150px;
    }
  }
}
#title {
  font-family: "Pacifico", cursive;
  font-size: 4em;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  @media screen and (max-width: 768px) {
    .container {
      padding-right: 5px;
      padding-left: 5px;
    }
  }
}
#nav > * {
  padding: 0px 5px;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
